import {
  Button,
  ButtonProps,
  Dialog,
  ThemeProvider,
  styled,
} from "@mui/material";
import "./ConfirmationPopup.scss";
import { BORDER_BOX_STYLE, COLOR_STEELBLUE, INTER_FONT_FAMILY, theme } from "../../utils/constants";
import images from "../../assets/images";
import { getScreenDimensions } from "../../utils/helper";

interface PropsType {
  open: boolean;
  message: string;
  gifData?: string;
  deleteForMeButtonFunctionality?: () => void;
  yesButtonFunctionality: () => void;
  noButtonFunctionality?: () => void;
  closeFunctionality? : () => void;
  messageWidth: string;
  page?: string;
  isForceUpdate?: boolean
  popupContainerHeight?: string;
}

interface StyledButtonProps extends ButtonProps {
  width?: string;
  variant?: "contained";
}

// Yes Button Style
const YesStyledButton = styled(Button)<StyledButtonProps>(() => ({
  fontFamily: INTER_FONT_FAMILY,
  fontSize: "12px",
  fontWeight: 700,
  cursor: "pointer",
  border: "0",
  backgroundColor: COLOR_STEELBLUE,
  borderRadius: "20px",
  height: "31px",
  width: "85px",
  display: "flex",
  color: "#ffffff",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: BORDER_BOX_STYLE,
  textTransform: "none",
  "&:hover": {
    backgroundColor: COLOR_STEELBLUE,
    color: "#ffffff",
  },
}));

// delete for me and delete for everyone Button Style
const DeleteStyledButton = styled(Button)<StyledButtonProps>(() => ({
  fontFamily: INTER_FONT_FAMILY,
  fontSize: "12px",
  fontWeight: 700,
  cursor: "pointer",
  border: "0",
  backgroundColor: COLOR_STEELBLUE,
  borderRadius: "20px",
  height: "31px",
  width: "160px",
  lineHeight: "12px",
  display: "flex",
  color: "#ffffff",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: BORDER_BOX_STYLE,
  textTransform: "none",
  "&:hover": {
    backgroundColor: COLOR_STEELBLUE,
    color: "#ffffff",
  },
}));

// No Button Style
const NoStyledButton = styled(Button)<StyledButtonProps>(() => ({
  fontFamily: INTER_FONT_FAMILY,
  fontSize: "12px",
  fontWeight: 700,
  cursor: "pointer",
  border: "0",
  backgroundColor: "#F3F7FA",
  borderRadius: "20px",
  height: "31px",
  width: "84px",
  display: "flex",
  color: "#000000",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: BORDER_BOX_STYLE,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#F3F7FA",
    color: "#000000",
  },
}));

// Cancel Button Style
const CancelStyledButton = styled(Button)<StyledButtonProps>(() => ({
  fontFamily: INTER_FONT_FAMILY,
  fontSize: "12px",
  fontWeight: 700,
  cursor: "pointer",
  border: "0",
  backgroundColor: "#F3F7FA",
  borderRadius: "20px",
  height: "31px",
  width: "160px",
  display: "flex",
  color: "#000000",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: BORDER_BOX_STYLE,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#F3F7FA",
    color: "#000000",
  },
}));

const ConfirmationPopup = ({
  open,
  message,
  gifData,
  messageWidth,
  deleteForMeButtonFunctionality,
  yesButtonFunctionality,
  noButtonFunctionality,
  closeFunctionality,
  page,
  isForceUpdate,
  popupContainerHeight
}: PropsType) => {
  const { closeIcon } = images;
  const { isMobileScreen } = getScreenDimensions();

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={open} classes={{ paper: "paperStyle" }}>
        <div
          className={
            page === "chat"
              ? "chatdialogMainContainer"
              : page === "forgotpassword" && isMobileScreen
              ? "fortgoutPasswordContainer"
              : "dialogMainContainer"
          }
          style={popupContainerHeight ? { height: popupContainerHeight } : undefined}
        >
          {(page === "logout" ||
            page === "forgotpassword" ||
            page === "meeting" ||
            page === "quiz") && (
            <div className={page === "meeting" || page === "quiz" ? "meetingdiv" : ""}>
              <img
                alt="closeIcon"
                src={closeIcon}
                className="closeIcon"
                onClick={page === "meeting" ? closeFunctionality : noButtonFunctionality}
                style={{ display: (page === "meeting" || (page === "quiz" && noButtonFunctionality)) ? "block" : "none" }}
              />
            </div>
          )}
          {page !== "selectVirtualProgram" && gifData && (
            <img src={gifData} alt="logoutGif" className="logoutGif" />
          )}
          <div
            className="messageStyle"
            style={{
              width: messageWidth,
              marginTop: page === "selectVirtualProgram" ? "30px" : "",
            }}
          >
            {message}
          </div>
          <div
            className={
              page === "chat"
                ? "chatCtaActions"
                : page === "meeting"
                ? "meetCtaActions"
                : "ctaActions"
            }
            style={{ marginTop: page === "selectVirtualProgram" ? "30px" : "" }}
          >
            {page === "chat" ? (
              <>
                <DeleteStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={deleteForMeButtonFunctionality}
                >
                  Delete for me
                </DeleteStyledButton>
                <DeleteStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={yesButtonFunctionality}
                >
                  Delete for everyone
                </DeleteStyledButton>
                <CancelStyledButton
                  variant="contained"
                  className="noBtnStyle"
                  disableElevation
                  onClick={noButtonFunctionality}
                >
                  Cancel
                </CancelStyledButton>
              </>
            ) : page === "AppUpdate" ? (
              <>
                <YesStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={yesButtonFunctionality}
                >
                  Update
                </YesStyledButton>
                {!isForceUpdate && (
                  <NoStyledButton
                    variant="contained"
                    className="noBtnStyle"
                    disableElevation
                    onClick={noButtonFunctionality}
                  >
                    Skip
                  </NoStyledButton>
                )}
              </>
            ) : page === "forgotpassword" ? (
              <YesStyledButton
                variant="contained"
                className="yesBtnStyle"
                disableElevation
                onClick={yesButtonFunctionality}
              >
                Ok
              </YesStyledButton>
            ) : 
            (page === 'okayCancel' || page === 'startTimedQuiz') ? (
              <>
                <YesStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={yesButtonFunctionality}
                >
                  Proceed
                </YesStyledButton>
                <NoStyledButton
                  variant="contained"
                  className="noBtnStyle"
                  disableElevation
                  onClick={noButtonFunctionality}
                >
                  Cancel
                </NoStyledButton>
              </>
            ) :
            page === 'quiz' ? (
              <YesStyledButton
                variant="contained"
                className="yesBtnStyle"
                disableElevation
                onClick={yesButtonFunctionality}
              >
                Proceed
              </YesStyledButton>
            ) :
            page === 'assignmentShare' ? (
              <>
                <YesStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={yesButtonFunctionality}
                >
                  Share
                </YesStyledButton>
                <NoStyledButton
                  variant="contained"
                  className="noBtnStyle"
                  disableElevation
                  width="95px"
                  sx={{
                    minWidth: '95px'
                  }}
                  onClick={noButtonFunctionality}
                >
                  Not Now
                </NoStyledButton>
              </>
            ) : page === "meeting" ? (
              <>
                <YesStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={yesButtonFunctionality}
                  fullWidth
                  sx={{
                    width: "100%",
                    backgroundColor: "#F3F7FA",
                    color: "#000000",
                    "&:hover": {
                      backgroundColor: "#F3F7FA",
                      color: "#000000",
                    },
                  }}
                >
                  {getScreenDimensions().isMobileScreen ? "Leave" : "Leave the meeting"}
                </YesStyledButton>
                <NoStyledButton
                  variant="contained"
                  className="noBtnStyle"
                  disableElevation
                  onClick={noButtonFunctionality}
                  sx={{
                    width: "100%",
                    backgroundColor: "#E90000",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#E90000",
                      color: "white",
                    },
                  }}
                  fullWidth
                >
                 {getScreenDimensions().isMobileScreen ? "End" : "End the meeting"}
                </NoStyledButton>
              </>
            ) :
            (
              <>
                <YesStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={yesButtonFunctionality}
                >
                  Yes
                </YesStyledButton>
                <NoStyledButton
                  variant="contained"
                  className="noBtnStyle"
                  disableElevation
                  onClick={noButtonFunctionality}
                >
                  No
                </NoStyledButton>
              </>
            )}
          </div>
        </div>
      </Dialog>
    </ThemeProvider>
  );
};

export default ConfirmationPopup;
